import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { FooterService } from '../../../shared/services/footer.service';
import { formatLastUpdated } from '../../../shared/utilities/date-formatter';
import { UserProfileService } from '../../../modules/usermanagement/services/user-profile.service';
import { ViewUserProfileResponse } from '../../../modules/usermanagement/models/user.model';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  userTimezoneUtcName?: string;

  lastUpdatedDate$: Observable<Date | null>;

  constructor(
    private footerService: FooterService,
    private userProfileService: UserProfileService
  ) {
    this.lastUpdatedDate$ = this.footerService.lastUpdatedDate$;
  }

  ngOnInit(): void {
    this.userProfileService.userProfile$
      .pipe(takeUntil(this.destroy$))
      .subscribe((profile: ViewUserProfileResponse | null) => {
        this.userTimezoneUtcName = profile?.timezoneUtcName;
      });
  }

  formatDate(date: Date | null): string {
    return date ? formatLastUpdated(date, this.userTimezoneUtcName) : '';
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
